"use client"

import { Banner } from "@/app/components/Banner"
import ServiceContent from "@/app/components/ServiceContent"
import { ecommerceImg } from "@/assets/imgs"
import { useTranslations } from "next-intl"


const Ecommerce = () => {
  const  t  = useTranslations()
  return (
    <>
      <Banner
        subUrl={t('links.services')}
        name={t('links.e_commerce' )}
        description={t('e_commerce.bannerDescription')}
        className='bg-ecommerceBanner'
      />
      <ServiceContent
        title={t('links.e_commerce')}
        header={t('e_commerce.header')}
        subContent={t('e_commerce.subTitle')}
        content={t('e_commerce.content')}
        img={ecommerceImg}
      />
    </>
  )
}

export default Ecommerce
